export interface PointTimeline {
  readonly seenAtMs: readonly number[];
  readonly lastObservedAtMs: number;
}

export function updatePointTimeline(
  current: PointTimeline | undefined,
  pointCount: number,
  observedAtMs: number,
  firstObservedAtMs = observedAtMs,
  cadenceMs = 0,
): PointTimeline {
  const timelineObservedAtMs = cadenceMs > 0
    ? Math.floor(observedAtMs / cadenceMs) * cadenceMs
    : observedAtMs;
  const timelineFirstObservedAtMs = cadenceMs > 0
    ? Math.floor(firstObservedAtMs / cadenceMs) * cadenceMs
    : firstObservedAtMs;
  if (!current) {
    const start = Math.min(timelineFirstObservedAtMs, timelineObservedAtMs);
    const duration = timelineObservedAtMs - start;
    const denominator = Math.max(1, pointCount - 1);
    return {
      seenAtMs: Array.from(
        { length: pointCount },
        (_, index) => start + duration * (index / denominator),
      ),
      lastObservedAtMs: timelineObservedAtMs,
    };
  }

  // Never refresh existing points. A sender may append to a stroke, but it
  // cannot keep the already-drawn head alive by revising or shrinking it.
  const seenAtMs = [...current.seenAtMs];
  while (seenAtMs.length < pointCount) seenAtMs.push(timelineObservedAtMs);
  return { seenAtMs, lastObservedAtMs: timelineObservedAtMs };
}

export function firstVisiblePointIndex(
  timeline: PointTimeline,
  pointCount: number,
  nowMs: number,
  lifetimeMs: number,
): number {
  const available = Math.min(pointCount, timeline.seenAtMs.length);
  for (let index = 0; index < available; index += 1) {
    if (nowMs - timeline.seenAtMs[index] <= lifetimeMs) return index;
  }
  return -1;
}

export function pointOpacity(
  timeline: PointTimeline | undefined,
  pointIndex: number,
  nowMs: number,
  lifetimeMs: number,
): number {
  const seenAtMs = timeline?.seenAtMs[pointIndex] ?? nowMs;
  return Math.max(0, Math.min(1, 1 - (nowMs - seenAtMs) / lifetimeMs));
}
